export default __webpack_public_path__ + "static/media/ic_china.f0107f72.svg";